import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../hooks/AuthContext";
import Loading from "../components/Loading";

const InternalRoute = ({ children }: { children: React.JSX.Element }) => {
  const { user, isLoading } = useContext(AuthContext);

  if (isLoading) {
    return <Loading />;
  }

  return user.userRole === "INTERNAL" || user.userRole === "ADMIN" ? (
    children
  ) : (
    <Navigate to="/login" />
  );
};

export default InternalRoute;
